import React from "react";
import { useSelector } from "react-redux";
import shared from "../../styles/UserProfileCommon.module.scss";
import styles from "../../styles/admanager/UserAdManagerEarnings.module.scss";
import { openNewWindow } from "../../utils/helperUtils";
import isLoggingInFromClient from "../../selectors/isLoggingInFromClient";
export default function UserAdEarnings() {
  const clientLoginState = useSelector(isLoggingInFromClient);
  const openUrl = (e) => {
    const url = "https://www.buildbox.com/rev-share-details/";
    e.preventDefault();
    if (clientLoginState) {
      openNewWindow(url, false);
    } else {
      window.open(url, "_blank");
    }
  };
  return (
    <div className={styles.userMonetizationWrapper}>
      <div className={shared.subHeader}>
        <div className={styles.detailsStaticText}>
          {" "}
          We start processing payments on the <b>15th of each month; </b>
          however, it may take a couple of days to reach your account.
        </div>
        <div className={styles.detailsStaticText}>
          If your transaction cannot be processed by the 15th, it will be
          processed in the following month’s pay cycle.
        </div>
        <div className={styles.detailsStaticText}>
          Revenue share depends on your plan.{" "}
          <button onClick={(e) => openUrl(e)} className={styles.eula}>
            Learn More
          </button>
        </div>
      </div>
    </div>
  );
}
